import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {OptimizationNodeOutputData} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {OptimizationCardScratchpadState} from '../../scratchpad/optimizationCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const addOptimizationOutputInputSchema = z.object({
  name: z.string().describe('The name of the output'),
});

export default function addOptimizationOutputTool() {
  async function execute(
    params: ToolExecuteParams<
      typeof addOptimizationOutputInputSchema,
      OptimizationCardScratchpadState
    >,
  ) {
    const {name} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<OptimizationCardScratchpadState>(
      agentScratchpad,
      NodeType.GENERAL_OPTIMIZATION,
    );

    const nextId =
      validatedScratchpad.card.outputs.length > 0
        ? Math.max(...validatedScratchpad.card.outputs.map((o) => o.id), 0) + 1
        : 1;

    const newOutput: OptimizationNodeOutputData = {
      id: nextId,
      nodeId: NO_NODE_ID,
      name,
      type: OutputType.Regular,
    };

    validatedScratchpad.card.outputs.push(newOutput);
    validatedScratchpad.card.variationsCount = validatedScratchpad.card.outputs.length;

    return toolResult(`Optimization output "${name}" added`);
  }

  return tool<typeof addOptimizationOutputInputSchema, OptimizationCardScratchpadState>({
    name: V2CardAgentToolName.AddOptimizationOutput,
    displayName: 'Adding optimization output',
    description: 'Add a new optimization output with a specific name.',
    inputSchema: addOptimizationOutputInputSchema,
    execute,
  });
}
